export default "__VITE_ASSET__9hS8vW70__"